import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  pt: {
    translation: {
      // Navigation
      nav: {
        home: "Início",
        activities: "Atividades",
        about: "Sobre Nós",
        blog: "Notícias",
        gallery: "Galeria",
        reviews: "Avaliações",
        contact: "Contato",
        admin: "Admin"
      },
      // Hero
      hero: {
        title: "Descubra o Rio Guadiana",
        subtitle: "Experiências náuticas inesquecíveis",
        bookNow: "Reservar Agora",
        learnMore: "Saber Mais"
      },
      // Activities
      activities: {
        title: "As Nossas Atividades",
        subtitle: "Escolha a sua aventura",
        bookNow: "Reservar",
        learnMore: "Saber mais",
        adult: "Adulto",
        child: "Criança",
        duration: "Duração",
        priceFrom: "A partir de"
      },
      // About
      about: {
        title: "Quem Somos",
        subtitle: "A nossa história",
        noTitle: "Quem é o Nó?",
        noSubtitle: "Cão de Água Português",
        noDescription: "O Nó é o nosso Cão de Água Português. Excelente marinheiro, salva-vidas, recoletor de lixo marinho, mariscador, e beijoqueiro. Dotado de uma capacidade tremenda para travar novas amizades, é talvez o elemento mais importante da nossa equipa e não há passeio de barco em que ele não queira participar."
      },
      // Blog
      blog: {
        title: "Novidades",
        subtitle: "Mantenha-se Informado",
        readMore: "Ler Mais",
        latest: "Últimas notícias"
      },
      // Reviews
      reviews: {
        title: "O Que Dizem de Nós",
        subtitle: "Avaliações dos nossos clientes",
        writeReview: "Escrever Avaliação",
        yourName: "O seu nome",
        yourComment: "O seu comentário",
        rating: "Avaliação",
        submit: "Enviar",
        thankYou: "Obrigado pela sua avaliação!"
      },
      // Contact
      contact: {
        title: "Fale Connosco",
        subtitle: "Estamos aqui para ajudar",
        name: "Nome",
        email: "Email",
        phone: "Telefone",
        message: "Mensagem",
        send: "Enviar",
        sending: "A enviar...",
        success: "Mensagem enviada com sucesso!",
        error: "Erro ao enviar mensagem. Tente novamente.",
        whatsapp: "Contacto via WhatsApp"
      },
      // Footer
      footer: {
        partners: "Parceiros",
        social: "Redes Sociais",
        rights: "Todos os direitos reservados"
      },
      // Common
      common: {
        loading: "A carregar...",
        error: "Erro",
        close: "Fechar",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
        edit: "Editar",
        add: "Adicionar"
      }
    }
  },
  en: {
    translation: {
      // Navigation
      nav: {
        home: "Home",
        activities: "Activities",
        about: "About Us",
        blog: "News",
        gallery: "Gallery",
        reviews: "Reviews",
        contact: "Contact",
        admin: "Admin"
      },
      // Hero
      hero: {
        title: "Discover the Guadiana River",
        subtitle: "Unforgettable nautical experiences",
        bookNow: "Book Now",
        learnMore: "Learn More"
      },
      // Activities
      activities: {
        title: "Our Activities",
        subtitle: "Choose your adventure",
        bookNow: "Book Now",
        learnMore: "Learn more",
        adult: "Adult",
        child: "Child",
        duration: "Duration",
        priceFrom: "From"
      },
      // About
      about: {
        title: "About Us",
        subtitle: "Our story",
        noTitle: "Who is Nó?",
        noSubtitle: "Portuguese Water Dog",
        noDescription: "Nó is our Portuguese Water Dog. Excellent sailor, lifeguard, marine litter collector, shellfish gatherer, and kiss giver. Gifted with a tremendous ability to make new friends, he is perhaps the most important member of our team and there is no boat trip he doesn't want to participate in."
      },
      // Blog
      blog: {
        title: "News",
        subtitle: "Stay Informed",
        readMore: "Read More",
        latest: "Latest news"
      },
      // Reviews
      reviews: {
        title: "What They Say About Us",
        subtitle: "Customer reviews",
        writeReview: "Write Review",
        yourName: "Your name",
        yourComment: "Your comment",
        rating: "Rating",
        submit: "Submit",
        thankYou: "Thank you for your review!"
      },
      // Contact
      contact: {
        title: "Contact Us",
        subtitle: "We're here to help",
        name: "Name",
        email: "Email",
        phone: "Phone",
        message: "Message",
        send: "Send",
        sending: "Sending...",
        success: "Message sent successfully!",
        error: "Error sending message. Please try again.",
        whatsapp: "Contact via WhatsApp"
      },
      // Footer
      footer: {
        partners: "Partners",
        social: "Social Media",
        rights: "All rights reserved"
      },
      // Common
      common: {
        loading: "Loading...",
        error: "Error",
        close: "Close",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        add: "Add"
      }
    }
  },
  es: {
    translation: {
      // Navigation
      nav: {
        home: "Inicio",
        activities: "Actividades",
        about: "Sobre Nosotros",
        blog: "Noticias",
        gallery: "Galería",
        reviews: "Reseñas",
        contact: "Contacto",
        admin: "Admin"
      },
      // Hero
      hero: {
        title: "Descubre el Río Guadiana",
        subtitle: "Experiencias náuticas inolvidables",
        bookNow: "Reservar Ahora",
        learnMore: "Más Información"
      },
      // Activities
      activities: {
        title: "Nuestras Actividades",
        subtitle: "Elija su aventura",
        bookNow: "Reservar",
        learnMore: "Saber más",
        adult: "Adulto",
        child: "Niño",
        duration: "Duración",
        priceFrom: "Desde"
      },
      // About
      about: {
        title: "Quiénes Somos",
        subtitle: "Nuestra historia",
        noTitle: "¿Quién es Nó?",
        noSubtitle: "Perro de Agua Portugués",
        noDescription: "Nó es nuestro Perro de Agua Portugués. Excelente marinero, socorrista, recolector de basura marina, mariscador y besucón. Dotado de una tremenda capacidad para hacer nuevos amigos, es quizás el miembro más importante de nuestro equipo y no hay viaje en barco en el que no quiera participar."
      },
      // Blog
      blog: {
        title: "Noticias",
        subtitle: "Manténgase Informado",
        readMore: "Leer Más",
        latest: "Últimas noticias"
      },
      // Reviews
      reviews: {
        title: "Lo Que Dicen de Nosotros",
        subtitle: "Reseñas de clientes",
        writeReview: "Escribir Reseña",
        yourName: "Su nombre",
        yourComment: "Su comentario",
        rating: "Calificación",
        submit: "Enviar",
        thankYou: "¡Gracias por su reseña!"
      },
      // Contact
      contact: {
        title: "Contáctenos",
        subtitle: "Estamos aquí para ayudar",
        name: "Nombre",
        email: "Correo electrónico",
        phone: "Teléfono",
        message: "Mensaje",
        send: "Enviar",
        sending: "Enviando...",
        success: "¡Mensaje enviado con éxito!",
        error: "Error al enviar el mensaje. Inténtelo de nuevo.",
        whatsapp: "Contacto vía WhatsApp"
      },
      // Footer
      footer: {
        partners: "Socios",
        social: "Redes Sociales",
        rights: "Todos los derechos reservados"
      },
      // Common
      common: {
        loading: "Cargando...",
        error: "Error",
        close: "Cerrar",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
        edit: "Editar",
        add: "Añadir"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt',
    supportedLngs: ['pt', 'en', 'es'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
